// extracted by mini-css-extract-plugin
export default {"Description":"_Description--fPRnR","PhoneNumberContainer":"_PhoneNumberContainer--Ocpw1","ActionsContainer":"_ActionsContainer--yOnGM","SkipButton":"_SkipButton--PvDAi"};